import React from 'react';
import { Typography } from '@mui/material';
import { InfoMessage } from 'components/InfoMessage';

type NotUploadedFilesWarningProps = {
  removedFiles: number;
  totalFiles: number;
};

export const NotUploadedFilesWarning = ({ removedFiles, totalFiles }: NotUploadedFilesWarningProps) => {
  return (
    <InfoMessage
      variant="warning"
      fullWidth
      title={`${removedFiles} von ${totalFiles} Creatives konnten nicht hochgeladen werden`}
      message={
        <Typography variant="body2">
          Schliesse zuerst diesen Vorgang ab und lade die noch fehlenden Creatives erneut hoch.
        </Typography>
      }
    />
  );
};
